<template>
	<el-drawer size="800px" :show-close="false" :visible="active" :before-close="closeDlg">
		<template slot="title">
			<div class="el-drawer-close" @click="closeDlg"><i class="el-icon el-icon-arrow-left"></i>返回</div>
			<el-button class="el-drawer-save" type="primary" size="mini" :loading="isLoading" @click="saveForm" v-if="!disabled">保存</el-button>
			{{item.name}}
		</template>
		<div class="drawer-content qst-form">
			<el-form ref="form" size="small" label-position="left" label-width="120px" :disabled="disabled" :model="form">
				<div class="item">
					<div class="caption">用药指导</div>
					<el-form-item label="用药依从性">
						<el-radio-group v-model="form.q1">
							<el-radio :label="1">规律</el-radio>
							<el-radio :label="2">间断</el-radio>
							<el-radio :label="3">不服药</el-radio>
							<el-radio :label="4">自行调药</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="药物不良反应">
						<el-radio-group v-model="form.q2.v1">
							<el-radio :label="2">无</el-radio>
							<el-radio :label="1">有</el-radio>
							<el-input style="width: 100px;" size="small" v-model="form.q2.other" v-if="form.q2.v1 == 1"></el-input> 
						</el-radio-group>
					</el-form-item>

				</div>
				<div class="item">
					<div class="caption">体征记录</div>
					<el-form-item label="血压（mmhg）">
						收缩压 <el-input style="width: 100px;" size="small" maxlength="18" v-model="form.q3.v1"></el-input> 
						舒张压 <el-input style="width: 100px;" size="small" maxlength="18" v-model="form.q3.v2"></el-input>
					</el-form-item>
					<el-form-item label="体重(kg)">
						<el-input style="width: 100px;" size="small" maxlength="6" v-model="form.q4"></el-input> 
					</el-form-item>
					<el-form-item label="身高(cm)">
						<el-input style="width: 100px;" size="small" maxlength="6" v-model="form.q5"></el-input> 
					</el-form-item>
				</div>
				<div class="item">
					<div class="caption">生活方式指导</div>
					<el-form-item label="吸烟情况">
						<div>
							<span class="lbl-s">吸烟史</span>
							<el-radio-group v-model="form.q6.v1">
								<el-radio :label="1">是</el-radio>
								<el-radio :label="2">否</el-radio>
							</el-radio-group>
						</div>
						<div>
							<span class="lbl-s">是否戒烟</span>
							<el-radio-group v-model="form.q6.v2">
								<el-radio :label="1">是</el-radio>
								<el-radio :label="2">否</el-radio>
							</el-radio-group>
						</div>
						<div><span class="lbl-s">日吸烟量</span><el-input style="width: 60px;" size="mini" maxlength="18" v-model="form.q6.other"></el-input> 支/日</div>
					</el-form-item>
					<el-form-item label="饮酒史">
						<div>
							<span class="lbl-s">饮酒史</span>
							<el-radio-group v-model="form.q7.v1">
								<el-radio :label="1">是</el-radio>
								<el-radio :label="2">否</el-radio>
							</el-radio-group>
						</div>
						<div>
							<span class="lbl-s">是否戒酒</span>
							<el-radio-group v-model="form.q7.v2">
								<el-radio :label="1">是</el-radio>
								<el-radio :label="2">否</el-radio>
							</el-radio-group>
						</div>
						<div><span class="lbl-s">日饮酒量</span><el-input style="width: 60px;" size="mini" maxlength="18" v-model="form.q7.other"></el-input> 两/日</div>							
					</el-form-item>
					<el-form-item label="运动">
						<div><span class="lbl-s">运动频率</span><el-input style="width: 60px;" size="mini" maxlength="18" v-model="form.q8.v1"></el-input> 次/周</div>
						<div><span class="lbl-s">运动时长</span><el-input style="width: 60px;" size="mini" maxlength="18" v-model="form.q8.v2"></el-input> 分钟/次</div>
					</el-form-item>
					
					<el-form-item label="心理调整">
						<div>
							<span class="lbl-s">心理状态</span>
							<el-radio-group v-model="form.q9">
								<el-radio :label="3">良好</el-radio>
								<el-radio :label="2">一般</el-radio>
								<el-radio :label="1">差</el-radio>
							</el-radio-group>
						</div>
					</el-form-item>

					<el-form-item label="睡眠调整">
						<div>
							<span class="lbl-s">睡眠质量</span>
							<el-radio-group v-model="form.q10.v1">
								<el-radio :label="3">良好</el-radio>
								<el-radio :label="2">一般</el-radio>
								<el-radio :label="1">差</el-radio>
							</el-radio-group>
						</div>
						<div><span class="lbl-s">平均睡眠时长</span><el-input style="width: 60px;" size="mini" maxlength="18" v-model="form.q10.other"></el-input> 小时/日</div>
					</el-form-item>	

					<el-form-item label="摄盐情况">
						<div>
							<span class="lbl-s">口味(咸淡)</span>
							<el-radio-group v-model="form.q11.v1">
								<el-radio :label="3">轻</el-radio>
								<el-radio :label="2">中</el-radio>
								<el-radio :label="1">重</el-radio>
							</el-radio-group>
						</div>
						<div><span class="lbl-s">平均摄入量</span><el-input style="width: 60px;" size="mini" maxlength="18" v-model="form.q11.other"></el-input> 克/天</div>
					</el-form-item>
					
				</div>

				<div class="item">
					<div class="caption">症状</div>
					<div>
						<el-radio-group v-model="form.q12.v1">
							<el-radio :label="1">有</el-radio>
							<el-radio :label="2">无</el-radio>
						</el-radio-group>
					</div>
					<div v-if="form.q12.v1 == 1">
						<el-checkbox-group v-model="form.q12.v2">
							<el-checkbox :label="1">头痛头晕</el-checkbox>
							<el-checkbox :label="2">恶心呕吐</el-checkbox>
							<el-checkbox :label="3">眼花耳鸣</el-checkbox>
							<el-checkbox :label="4">呼吸困难</el-checkbox>
							<el-checkbox :label="5">心悸胸闷</el-checkbox>
							<el-checkbox :label="6">鼻衄出血</el-checkbox> 
							<el-checkbox :label="7">四肢发麻</el-checkbox> 
							<el-checkbox :label="8">下肢水肿</el-checkbox>
						</el-checkbox-group>
					</div>
				</div>


			</el-form>

		</div>
	</el-drawer>
</template>

<script>
import api from '@/service/api.js';
import mixin from '@/views/mixin';

export default {
	mixins: [mixin],
	props: {item: {required: true}, disabled: {required: true}},
	data(){
		return {
			noSidebar: true,
			active: false,
			form: {
				dictId: 0,
				q1: '', 
				q2: {v1: '', other: ''}, 
				q3: {v1: '', v2: ''}, 
				q4: '', 
				q5: '', 
				q6: {v1: '', v2: '', other: ''}, 
				q7: {v1: '', v2: '', other: ''}, 
				q8: {v1: '', v2: ''},
				q9: '',
				q10: {v1: '', other: ''},
				q11: {v1: '', other: ''},
				q12: {v1: '', v2: []},
			},
			patientId: 0
		}
	},
	created() {this.init();},
	methods: {
		async init() {
			if (this.item.resultJson && this.item.resultJson.length > 0) {
				this.form = JSON.parse(this.item.resultJson);
			}
			this.$nextTick(async ()=>{
				this.form.dictId = this.item.dictId;
				this.active = true;
				this.patientId = +this.$route.query.patientId;
			});
		},
		closeDlg() {
			this.$emit('close');
		},
		async saveForm() {
			let form  = this.form;
			// if (form.q1 == '') {
			// 	return this.$message.warning('请完整填写问卷内容');
			// }
			// if (form.q2.v1 == '' || (form.q2.v1 == 1 && form.q2.other.trim() == '')) {
			// 	return this.$message.warning('请完整填写问卷内容');
			// }
			// if (form.q3.v1.trim() == '' || form.q3.v2.trim() == '') {
			// 	return this.$message.warning('请完整填写问卷内容');
			// }
			// if (form.q4.trim() == '') {
			// 	return this.$message.warning('请完整填写问卷内容');
			// }
			// if (form.q5.trim() == '') {
			// 	return this.$message.warning('请完整填写问卷内容');
			// }
			// if (form.q6.v1 == '' || form.q6.v2 == '' || form.q6.other.trim() == '') {
			// 	return this.$message.warning('请完整填写问卷内容');
			// }
			// if (form.q7.v1 == '' || form.q7.v2 == '' || form.q7.other.trim() == '') {
			// 	return this.$message.warning('请完整填写问卷内容');
			// }
			// if (form.q8.v1.trim() == '' || form.q8.v2.trim() == '') {
			// 	return this.$message.warning('请完整填写问卷内容');
			// }
			// if (form.q9 == '') {
			// 	return this.$message.warning('请完整填写问卷内容');
			// }
			// if (form.q10.v1 == '' || form.q10.other.trim() == '') {
			// 	return this.$message.warning('请完整填写问卷内容');
			// }
			// if (form.q11.v1 == '' || form.q11.other.trim() == '') {
			// 	return this.$message.warning('请完整填写问卷内容11');
			// }
			// if (form.q12.v1 == '' || (form.q12.v1 == 1 && form.q12.v2.length == 0)) {
			// 	return this.$message.warning('请完整填写问卷内容');
			// }
			this.isLoading = true;
			let res = await api.submitFollowupQuestionnaire({dataId: this.item.dataId, dictId: this.item.dictId, patientId: this.patientId, resultJson: JSON.stringify(form)});
			this.isLoading = false;
			if (res.code != 1000) {return this.$message.error(res.message);}
			this.$message.success('保存成功');
			this.$emit('update', form);
		},
	}
}
</script>

<style lang="less" scoped>
@import './template.less';	
</style>
